'use client'

import { memo, useState } from 'react'

import { usePermission } from '@features/permissions/permissions'
import { Button } from '@fp/ui-kit'

export const ExportCsvButton = memo(({ csvExportingHandle }: { csvExportingHandle?: () => Promise<void> }) => {
  const [isLoading, setIsLoading] = useState(false)
  // Backend `ExportsController#index` → `exports.read`, shared by every table export.
  const canExport = usePermission('exports.read')

  const handleClick = async () => {
    if (!csvExportingHandle) return

    setIsLoading(true)
    // The fetcher already toasts and reports a failed request; just re-enable the button so the user can retry.
    try {
      await csvExportingHandle()
    } catch {
      // handled by the fetcher
    } finally {
      setIsLoading(false)
    }
  }

  return (
    canExport &&
    csvExportingHandle && (
      <Button onClick={handleClick} isLoading={isLoading} disabled={isLoading} className='ml-auto'>
        Export CSV
      </Button>
    )
  )
})
